import { Getter, Setter, Store } from '@types'

/** Texts are hardcoded in Spanish; keep as identity for dynamic labels. */
export function t(
  _set: Setter,
  _get: Getter,
  str: number | keyof Store['textos']['textos'] | string,
): string {
  if (str === null || str === undefined) return ''
  return String(str)
}

export async function setTextos(get: Getter, set: Setter, textos: Store['textos']) {
  set((store) => {
    store.textos = textos
  })
}
